import { prepareCompetences, setSnackbar } from '@/helpers';
import { getSelectedCompenteces, setSelectedCompenteces, deselectedCompenteces } from '../../Api/ApiDepartments';
import { getRequest } from '@/System/Store/endpoints';

const state = {
    selectedPayload: [],
    deselectedPayload: [],
    competences: [],
    competences_categories: [],
};

const mutations = {
    UPDATE_COMPETENCE(state, competence) {
        const index = state.competences.findIndex((c) => c.id === competence.id);
        state.competences.splice(index, 1, competence);
    },
    SET_COMPETENCES(state, competences) {
        const selected = [];
        let preSelected = [];

        if (competences.length > 0) {
            competences.forEach((item) => {
                item.state = 'none';

                if ('data' in item && item.data.length > 0) {
                    const matches = item.data.filter((c) => c.selected === true);

                    const temp = matches.map((item) => {
                        return item.id;
                    });

                    if (matches.length > 0) {
                        item.state = 'few';
                    }

                    if (item.data.length === matches.length) {
                        item.state = 'all';
                    }

                    preSelected = preSelected.concat(temp);
                    selected.push(temp);

                    // Is all items under category checked?
                    item.selected = matches.length > 0;
                }
            });
        }

        state.competences = competences;
        state.selectedPayload = preSelected;
        state.deselectedPayload = [];
    },
    TOGGLE_CHILD_CHECKBOX(state, obj) {
        let item = null;

        if (obj && typeof obj === 'object' && obj?.cat && obj?.item) {
            const catIndex = state.competences.findIndex((c) => c.id === obj.cat);
            item = state.competences[catIndex].data.find((i) => i.id === obj.item);
        } else {
            item = state.competences.find((i) => i.id === obj);
        }

        item.selected = !item.selected;
        if (!item.selected) {
            state.deselectedPayload.push(item.id);
        }
    },
    TOGGLE_PARENT_CHECKBOX: (state, categoryId) => {
        const category = state.competences.find((c) => c.id === categoryId);
        category.selected = !category.selected;

        if (category.selected === true) {
            category?.data.forEach((item) => {
                item.selected = true;
            });
            return;
        }

        if (category.selected === false) {
            category?.data.forEach((item) => {
                item.selected = false;
            });
            return;
        }
    },
    TOGGLE_ALL(state, obj) {
        const catIndex = state.competences.findIndex((c) => c.id === obj.catId);
        const data = state.competences[catIndex].data;

        data.forEach((item) => {
            const index = state.selectedPayload.findIndex((i) => i === item.id);

            if (obj.all) {
                if (!state.selectedPayload.includes(item.id)) {
                    item.selected = true;
                    state.selectedPayload.push(item.id);
                }
            } else {
                if (index >= 0) {
                    item.selected = false;
                    state.selectedPayload.splice(index, 1);
                }
            }
        });
    },
    ACCORDION_TOGGLE_ITEM: (state, ids) => {
        const catIndex = state.competences.findIndex((c) => c.id === ids.catId);
        const item = state.competences[catIndex].data.find((i) => i.id === ids.item);

        item.toggled = !item.toggled;
    },
    SAVE_SELECTED_CHILD(state, obj) {
        if (state.selectedPayload.includes(obj.item)) {
            const index = state.selectedPayload.findIndex((i) => i === obj.item);
            state.selectedPayload.splice(index, 1);
        } else {
            state.selectedPayload.push(obj.item);
        }
    },
    SAVE_CATEGORY_STATE: (state, categoryId) => {
        const category = state.competences.find((c) => c.id === categoryId);

        if (category.state === 'none') {
            category.state = 'all';
            category.selected = true;

            category?.data.forEach((item) => {
                item.selected = true;
                state.selectedPayload.push(item.id);
            });

            return;
        }

        if (category.state === 'all' || category.state === 'few') {
            category.state = 'none';
            category.selected = false;

            category?.data.forEach((item) => {
                const index = state.selectedPayload.findIndex((i) => i === item.id);
                state.selectedPayload.splice(index, 1);
                item.selected = false;
            });

            return;
        }
    },
    SORT_COMPETENCES: (state, order) => {
        state.competences = state.competences.sort((a, b) => {
            if (order === 'asc') {
                return a.name.localeCompare(b.name);
            }
            if (order === 'desc') {
                return b.name.localeCompare(a.name);
            }
            if (order === 'selected') {
                if (a.selected === b.selected) {
                    return 0;
                }
                return a.selected ? -1 : 1;
            }
            return 0;
        });
    },
    SET_COMPETENCES_CATEGORIES: (state, array) => (state.competences_categories = array),
};

const actions = {
    async GET_COMPETENCES({ commit }, asCategoryArray = false) {
        return await getSelectedCompenteces().then((response) => {
            let competences = [];

            if (response.status === 'Success') {
                if (response.data.length > 0) {
                    competences = asCategoryArray ? prepareCompetences(response.data) : response.data;
                    commit('SET_COMPETENCES', competences);
                }
            }

            return competences;
        });
    },
    async GET_COMPETENCES_WITH_CATEGORY({ commit }, asCategoryArray = true) {
        return await getSelectedCompenteces().then((response) => {
            let competences = [];

            if (response.status === 'Success') {
                if (response.data.length > 0) {
                    competences = asCategoryArray ? prepareCompetences(response.data) : response.data;
                    commit('SET_COMPETENCES', competences);
                }
            }

            return competences;
        });
    },
    async GET_COMPETENCES_WITH_VALID_CATEGORY({ commit }, asCategoryArray = true) {
        return await getSelectedCompenteces().then((response) => {
            let competences = [];

            if (response.status === 'Success') {
                if (response.data.length > 0) {
                    competences = asCategoryArray
                        ? prepareCompetences(response.data.filter((competence) => competence.category))
                        : response.data.filter((competence) => competence.category);
                    commit('SET_COMPETENCES', competences);
                }
            }

            return competences;
        });
    },
    async SET_SELECTED_COMPETENCES({ commit, dispatch, state }, asCategoryArray = true) {
        if (state.deselectedPayload.length == 0) {
            return await setSelectedCompenteces({ competences: state.selectedPayload }).then((response) => {
                let competences = [];

                dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(response), { root: true });

                if (response.status === 'Success') {
                    competences = asCategoryArray ? prepareCompetences(response.data) : response.data;
                }
                return competences;
            });
        } else {
            return await deselectedCompenteces({ competences: state.deselectedPayload }).then((response) => {
                let competences = [];

                dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(response), { root: true });

                if (response.status === 'Success') {
                    competences = asCategoryArray ? prepareCompetences(response.data) : response.data;
                    commit('SET_COMPETENCES', competences);
                }

                return competences;
            });
        }
    },
    GET_COMPETENCES_CATEGORIES({ commit }) {
        getRequest(`/departments/competences/categories`).then((response) => {
            if (response.status === 'Success') {
                commit('SET_COMPETENCES_CATEGORIES', response.data);
            }
        });
    },
};

const getters = {
    GET_COMPETENCES: (state) => state.competences,
    GET_SELECTED_ACCORDIONS: (state) => state.selectedPayload,
    GET_COMPETENCES_CATEGORIES: (state) => state.competences_categories,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
